type Props = {
  checked: boolean;
  label: string;
  disabled?: boolean;
  onClick: () => void;
};

/** On/off switch of a pack setting; the caller saves on click. */
export function Switch({ checked, label, disabled, onClick }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={onClick}
      className={`relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
        checked ? 'bg-[var(--co-brand)]' : 'bg-[var(--co-border)]'
      }`}
    >
      <span
        className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${
          checked ? 'translate-x-[18px]' : 'translate-x-0.5'
        }`}
      />
    </button>
  );
}
